import template from './warnLastDay.html';
import controller from './warnLastDay.controller';
import './warnLastDay.scss';

let warnLastDayComponent = {
  restrict: 'E',
  bindings: {
    date: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default warnLastDayComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/warnLastDay/warnLastDay.component.js